import React from "react";
import { withStyles } from "@material-ui/styles";
import classNames from "classnames";
import styleConstants from "../../styleConstants";
import Accordion from "./Accordion";
import HyperLink from "../widgets/HyperLink";
import facebookIcon from "../../images/icons/facebook.svg";
import twitterIcon from "../../images/icons/twitter.svg";
import youTubeIcon from "../../images/icons/youtube.svg";

const styles = {
  accordion: {
    flex: 60
  },
  container: {
    padding: "6rem",
    display: "flex"
  },
  content: {
    marginLeft: "4rem",
    flex: "0 0 30%"
  },
  socialLinkList: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  socialLink: {
    margin: "1rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `1px ${styleConstants.colors.themeBlue} solid`,
    "& > a": {
      padding: "0.5rem 0.5rem 0.25rem",
      "&:hover": {
        backgroundColor: styleConstants.colors.themeBlueLight
      }
    }
  },
  siteLinkList: {
    listStyleType: "none",
    marginBottom: "2rem"
  },
  siteLink: {
    margin: "1rem 0"
  }
};

const ReadersGuide = props => (
  <div className={classNames("ReadersGuide", props.classes.container)}>
    <div className={props.classes.accordion}>
      <Accordion />
    </div>

    <div className={props.classes.content}>
      <ul className={props.classes.socialLinkList}>
        <li className={props.classes.socialLink}>
          <HyperLink href="https://www.facebook.com/rhsupplies" icon={true}>
            <img src={facebookIcon} alt="Facebook icon" />
          </HyperLink>
        </li>
        <li className={props.classes.socialLink}>
          <HyperLink href="https://twitter.com/Rh_Supplies" icon={true}>
            <img src={twitterIcon} alt="Twitter icon" />
          </HyperLink>
        </li>
        <li className={props.classes.socialLink}>
          <HyperLink
            href="https://www.youtube.com/channel/UCfcw-_6hiSEQMdR1ltXMeTw"
            icon={true}
          >
            <img src={youTubeIcon} alt="YouTube icon" />
          </HyperLink>
        </li>
      </ul>

      <ul className={props.classes.siteLinkList}>
        <li className={props.classes.siteLink}>
          <HyperLink href="https://www.rhsupplies.org/contact-us/">
            Contact Us
          </HyperLink>
        </li>
        <li className={props.classes.siteLink}>
          <HyperLink href="https://www.rhsupplies.org/terms-conditions/">
            Terms &amp; Conditions
          </HyperLink>
        </li>
        <li className={props.classes.siteLink}>
          <HyperLink href="https://www.rhsupplies.org/cookies-privacy-policy/">
            Cookies &amp; Privacy Policy
          </HyperLink>
        </li>
        <li className={props.classes.siteLink}>
          <HyperLink href="https://www.rhsupplies.org/">RHSC Home</HyperLink>
        </li>
      </ul>
      <div>&copy; Reproductive Health Supplies Coalition 2019</div>
    </div>
  </div>
);

export default withStyles(styles)(ReadersGuide);
